import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  FaTachometerAlt, 
  FaProjectDiagram, 
  FaCalendarAlt, 
  FaEnvelope,
  FaNewspaper,
  FaChartLine,
  FaBox
} from 'react-icons/fa';

const AdminSidebar = ({ isOpen, onClose, collapsed, onToggleCollapse }) => {
    const menuItems = [
    { path: '/dashboard', icon: <FaTachometerAlt />, label: 'Dashboard' },
    { path: '/projects', icon: <FaProjectDiagram />, label: 'Projects' },
    { path: '/articles', icon: <FaNewspaper />, label: 'Articles' },
    // { path: '/events', icon: <FaCalendarAlt />, label: 'Events' },
    { path: '/contact', icon: <FaEnvelope />, label: 'Messages' },
    { path: '/newsletter', icon: <FaBox />, label: 'Newsletter' },
    { path: '/statistics', icon: <FaChartLine />, label: 'Statistics' },
  ];

  return (
    <>
      {/* Overlay mobile */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed inset-y-0 left-0 z-30 bg-gray-900 text-white transform transition-all duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0 lg:static lg:inset-0
        ${collapsed ? 'w-16' : 'w-64'}
      `}>
        <div className="flex items-center justify-between h-16 px-4 border-b border-gray-800">
          <div className={`flex items-center ${collapsed ? 'justify-center w-full' : 'space-x-2'}`}>
            <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center flex-shrink-0">
              <FaBox size={18} />
            </div>
            {!collapsed && <span className="text-lg font-bold">EFIS Admin</span>}
          </div>
          <button
            onClick={onClose}
            className="lg:hidden p-2 rounded-md hover:bg-gray-800"
          >
            ✕
          </button>
        </div>

        <nav className={`${collapsed ? 'px-2' : 'p-4'}`}>
          <ul className="space-y-2">
            {menuItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => `
                    flex items-center ${collapsed ? 'justify-center' : 'space-x-3'} px-4 py-3 rounded-lg transition
                    ${isActive 
                      ? 'bg-purple-600 text-white' 
                      : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                    }
                  `}
                  title={collapsed ? item.label : ''}
                >
                  <span className="text-xl">{item.icon}</span>
                  {!collapsed && <span>{item.label}</span>}
                </NavLink>
              </li>
            ))}           
          </ul>
        </nav>

        {/* Footer Sidebar */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-800">
          <div className={`text-xs text-gray-400 ${collapsed ? 'text-center' : ''}`}>
            {collapsed ? (
              <p>v1.0</p>
            ) : (
              <>
                <p className="mt-1">© 2026 EFIS</p>
              </>
            )}
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;